import { InvoiceStatus } from '@link/agent/services/const';

export default {
  common: {
    search: '검색',
    keyword: '키워드',
    cancelAll: '일괄 취소',
    complete: '완료'
  },
  layouts: {
    sidebar: {
      notifications: '알림',
      contractsList: '계약 관리',
      agents: 'OTA 관리',
      booking: '예약',
      settings: '설정',
      changePassword: '비밀번호 변경',
      finance: '결제 관리',
      bulkOrder: '일괄 예약',
      activityList: '판매 상품 목록'
    }
  },
  views: {
    activityList: {
      pageTitle: '판매 상품 목록',
      searchTitle: '상품 검색',
      activityId: '상품 ID',
      activityUrl: '상품 URL',
      title: '상품명',
      supplier: '공급사',
      supplierId: '공급사 ID',
      supplierName: '공급사명',
      category: '카테고리',
      country: '상품 국가・지역',
      confirmationType: '재고 유형',
      inSalePeriod: '판매 기간 내',
      unspecified: '지정 안 함',
      salePeriod: '판매 기간',
      netPrice: '도매가',
      grossPrice: '판매가(GROSS)',
      unlimited: '무기한',
      downloadCsv: 'CSV 다운로드',
      snapshotHint:
        '표시된 데이터는 전일 기준입니다(매일 심야 업데이트). 최종 업데이트: {{time}}'
    },
    bulkBookingDetail: {
      history: '작업 내용',
      action: '작업',
      operator: '작업자',
      date: '날짜',
      message: '메시지',
      notifyPayment: '송금 알림',
      paymentDate: '송금일',
      paymentConfirmed: '송금을 확인했습니다',
      infoSentToSupplier: '정보가 공급사에 전송되었습니다.'
    },
    bulkBookingForm: {
      operator: '작업자',
      paymentDate: '송금 예정일',
      message: '메시지',
      agentReservationNo: 'OTA 예약번호(비고)',
      agentReservationNote: 'OTA 예약 특이사항'
    },
    addPrepayment: {
      agentId: 'OTA ID',
      agentName: 'OTA명',
      address: '회사 주소',
      date: '결제 기한',
      currency: '통화',
      amount: '결제 금액',
      note: 'LINKTIVITY 영업 담당자에게 선결제 청구서를 이메일로 송부해 주세요.',
      submit: '선불 청구서 생성',
      reset: '리셋'
    },
    financeHistory: {
      title: '결제 내역',
      dataAggregation: '데이터 집계',
      aggregationUnit: '집계 단위',
      targetPeriod: '대상 기간',
      monthly: '월간',
      weekly: '격주 단위',
      confirmed: '확정 완료',
      canceledRefund: '취소 환불',
      differenceAdjusted: '차액 조정 완료',
      totalAmount: '합계 금액',
      cancellationFee: '(내, 취소 수수료)',
      totalPaymentAmount: '결제 금액 합계',
      price: '({{currency}})',
      salesPrice: '판매 가격',
      wholesalePrice: '도매가',
      commission: '커미션',
      transactionSearch: '거래 검색',
      applicationDate: '신청일',
      participationDate: '참가일',
      transactionStatus: '거래 상태',
      keyword: '키워드',
      activity: '상품',
      plan: '플랜',
      supplier: '공급사',
      reservationNumber: '예약번호',
      currency: '통화'
    },
    financeTransactions: {
      title: '정산서',
      transactionStatus: '정산 상태',
      difference: '차액 조정',
      dueDate: '청구서 발행일',
      invoiceNumber: '청구서 ID',
      date: '청구 시기',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: '통화',
      amount: '결제 금액 합계',
      adjustedAmount: '조정 금액',
      finalAmount: '최종 합계 금액',
      adjust: '조정',
      showjust: '표시',
      change: '결제 완료',
      invoice: '청구 내역',
      jaInvoice: '지불 통지서(일본어)',
      jaInvoiceDetails: '명세서(일본어)',
      enInvoice: '지불 통지서(영문)',
      enInvoiceDetails: '명세서(영문)',
      attachment: '첨부 파일',
      changeTitle: '결제 완료되었습니까?',
      changeMessage: '거래 상태를 “결제 완료”로 변경합니다'
    },
    financeAccount: {
      title: '잔액 관리',
      listTitle: '충전 이력',
      accountBalance: '계정 잔액',
      accountBuffer: '계정 버퍼',
      deposit: '충전하기',
      generatePrepaidInvoice: '선불 청구서 생성',
      billingCycle: '결제 사이클',
      paymentMethod: '결제 방법',
      currency: '통화',
      contractNote: '위 설정은 계약 내용에 기반합니다.',
      contactSupport: '변경이 필요한 경우 LINKTIVITY 담당자에게 문의해 주세요.',
      date: '일시',
      amount: '금액',
      prepaidInvoice: '선불 청구서',
      transactionStatus: '상태',
      remark: '비고',
      accountBalanceAmount: '충전 전 잔액',
      accountBalanceAfterAmount: '충전 후 잔액',
      accountBufferAmount: '예비 잔액 (Account Buffer)',
      verificationCode: '확인코드',
      enterDepositAmount: '충전 금액을 입력해 주세요',
      depositAmount: '충전 금액',
      proceedToPayment: '결제 절차 진행',
      chargeCompleted: '송금 완료',
      cancel: '취소',
      confirmChargeCompleted: 'LINKTIVITY에 송금 완료를 통지합니다.',
      changeStatusToCharged: '상태를 "송금 완료"로 변경합니다.',
      change: '작업',
      confirmCancel: '취소하시겠습니까?',
      changeStatusToCancelled: '상태를 "취소"로 변경합니다.',
      insufficientBalanceNotification: '잔액 부족 알림 설정',
      notificationDialogTitle: '잔액 부족 알림 설정',
      notificationDialogSubtitle:
        '잔액이 지정 금액 이하가 되면 이메일로 알려드립니다.',
      notificationReceiveLabel: '알림 수신',
      notificationEnabled: '수신',
      notificationDisabled: '수신 안 함',
      notificationThresholdLabel: '알림 지정 잔액',
      notificationSave: '설정 저장'
    },
    dashboard: {
      title: '대시보드'
    },
    searchActivities: {
      title: '신규 예약',
      filter: {
        lang: '게시 언어',
        otaId: 'OTA',
        supplierId: '공급사',
        categories: '카테고리',
        country: '출발지',
        activityTitle: '상품명'
      },
      plan: '플랜',
      openBookingForm: '예약 폼 열기',
      viewDetail: '상세 보기',
      total: '검색 결과·{{total}}건',
      location: '{{country}}',
      city: '・{{city}}',
      supplier: '{{name}}({{id}})'
    },
    activityDetail: {
      plan: '플랜 선택',
      plans: {
        stockAndPrice: '재고·가격',
        calendar: '재고 캘린더',
        priceCalendar: '가격 캘린더',
        quantity: '재고 수량',
        currentPrice: '당일 가격',
        noDateSelected: '날짜를 선택해 주세요',
        unit: '단위',
        displayPrice: '판매 가격',
        netPrice: '도매가',
        otherDate: '다른 적용일',
        priceTable: '가격표',
        priceGroup: '요금 그룹',
        applicablePeriod: '적용 기간',
        cannotBeBookIndependently: '단독 구매 불가',
        commission: '커미션'
      }
    },
    bookingForm: {
      title: '예약 폼',
      steps: {
        step1: '기본 정보',
        step2: '예약 시 필요 정보',
        step3: '예약 신청'
      },
      prev: '이전 단계',
      next: '다음 단계',
      form: {
        plans: '플랜',
        targetDate: '참가일',
        time: '시작 시간',
        amount: '인원',
        amountDesc: '예약 수량 제한: {{capacity}}',
        amountDescBulk:
          '예약 수량 제한: {{capacity}}; 1회 예약 시 각 유닛당 최대 999장까지 가능합니다.',
        accountBalance: '계정 잔액',
        availableAmount: '이용 가능 금액',
        checkPrice: '잔여 수량 및 가격 확인',
        checkList: '참가 제한',
        checkListTip: '예약 전 확인해 주세요',
        operator: '작업자',
        paymentDate: '송금 예정일',
        message: '메시지',
        requiredInfo: '필수 정보',
        requiredInfoPerParticipant: '필수 정보(참가자별)',
        allotmentQuantity: '수량 {{quantity}}',
        paymentCurrency: '결제 금액(판매가)',
        totalPriceForBooking: '현지 통화 합계 금액',
        paymentCurrencyExchange: '환율',
        unit: '단위',
        representative: '참가자 대표',
        pleaseSelectUnit: '유닛을 선택하세요.',
        displayPrice: '판매 가격',
        netPrice: '도매가'
      },
      bookingConfirmation: {
        title: '예약 접수 완료',
        message: '신청이 완료되어 공급사로 정보가 전송되었습니다',
        reservationNumber: '예약번호',
        print: '인쇄용',
        display: '표시용'
      },
      participantInfo: {
        firstName: '대표자(이름)',
        lastName: '대표자(성)',
        agentReservationNo: 'OTA 예약번호(비고)',
        agentReservationNote: 'OTA 예약 특이사항'
      },

      bookingFields: {
        participantEmailAddress: '참가자 이메일 주소',
        hotelName: '숙박지명',
        hotelAddress: '숙박지 주소',
        hotelReservationLastName: '숙박 대표자 성(姓)',
        hotelReservationFirstName: '숙박 대표자 이름(名)',
        hotelReservationName: '숙박 대표자명',
        hotelTel: '숙박지 전화번호',
        arrivalDate: '현지 도착일',
        arrivalTime: '도착 시각',
        arrivalFlightNumber: '항공 도착편명',
        departureDate: '출발일',
        departureTime: '출발 시각',
        departureFlightNumber: '항공 출발편명',
        destinationEmail: '현지 연락처(이메일)',
        destinationTel: '현지 연락처(전화번호)',
        gender: '성별',
        agentChannelRegion: 'OTA소재국・지역',
        agentChannelLanguage: 'OTA 언어',
        participantResidentRegion: '참가자 거주 국가·지역',
        participantLanguage: '참가자 언어',
        passengersQuantity: '탑승 인원',
        prescriptionMaskQuantityFree: '도수 렌즈 마스크 요청 ※무료',
        prescriptionMaskQuantityPaid: '도수 렌즈 마스크 요청 ※현장 결제',
        preferredStartTime: '희망 시작 시간',
        preferredPickUpLocation: '픽업/승차 장소',
        preferredDropOffLocation: '하차/드롭오프 장소',
        participantsQuantity: '참가 인원',
        luggageQuantity: '여행 가방 수(합계)',
        childrenWithoutSeatQuantity: '좌석 불필요 유아',
        childSeatQuantityPaid: '카시트 이용(현장 결제)',
        childSeatQuantityFree: '카시트 이용(무료)',
        guideJa: '일본어 가이드 요청',
        driverJa: '일본어 드라이버 요청',
        guideEn: '영어 가이드 요청',
        driverEn: '영어 드라이버 요청',
        guideZh: '중국어 가이드 요청',
        driverZh: '중국어 드라이버 요청',
        guideKo: '한국어 가이드 희망',
        driverKo: '한국어 드라이버 희망',
        preferredGuideLanguageCode: '희망 가이드 언어',
        preferredDriverLanguageCode: '희망 드라이버 언어',
        passportNationality: '국적',
        passportFirstName: '참가자 이름(여권 로마자 표기)',
        passportLastName: '참가자 성(여권 로마자 표기)',
        dateOfBirth: '생년월일',
        age: '나이',
        passportNumber: '여권 번호',
        eyesight: '시력',
        weightKg: '체중 (kg)',
        heightCm: '신장(cm)',
        shoeSizeCm: '신발 사이즈(cm)',
        weightLbs: '체중 (lbs)',
        heightIn: '신장(ft/in)',
        clothesSize: '의류 사이즈',
        vegetarianMeals: '채식 희망',
        divingExperienceTimes: '다이빙 경험 횟수',
        rentalEquipmentsFree: '장비 렌탈 희망 ※무료',
        rentalEquipmentsPayLocally: '장비 렌탈 희망 ※현지 지불',
        male: '남성',
        female: '여성',
        other: '기타',
        yes: '예',
        no: '아니오'
      },

      alert: {
        warning:
          '희망 날짜에 이용 가능한 재고 수가 희망 인원보다 적습니다. 날짜 또는 인원을 변경해 주세요',
        info: '취소 정책에 동의하고 신청합니다',
        cannotBookAlone: '선택한 티켓은 단독 구매가 불가능합니다'
      }
    },
    reservations: {
      title: '미확정 예약'
    },
    agentDetail: {
      title: 'OTA 정보'
    },
    orgList: {
      title: '그룹 관리'
    },
    agentAccountList: {
      title: '계정 관리'
    },
    bookReservations: {
      paymentAppliedDate: '결제 신청일',
      id: 'ID',
      productPlan: '상품/플랜',
      expirationDate: '유효기간',
      participationDate: '참가일(현지 상품)',
      holdReservation: '미확정 예약',
      count: '건'
    }
  },
  const: {
    allotmentStatus: {
      plenty: '재고 있음',
      insufficient: '재고 부족',
      empty: '재고 없음',
      unavailable: '판매 불가'
    },
    bookingStatus: {
      yes: '예약 가능',
      no: '예약 불가'
    },
    activityTags: {
      NON_CANCELLABLE: '취소 불가',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: '교환 전 취소 무료',
      ADVANCE_CANCELLATION_POLICY: '특별 취소 정책',
      INSTANT_BOOK: '즉시 예약',
      NON_QR_CODE: '실물 바우처',
      QR_CODE: 'QR 바우처',
      ETICKET: '모기리 티켓(스마트폰 필요)'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '미결제',
      [InvoiceStatus.InvoiceStatusConfirmed]: '결제 완료',
      [InvoiceStatus.InvoiceStatusPaid]: '입금 확인 중',
      [InvoiceStatus.InvoiceStatusCancelled]: '취소 완료'
    }
  }
};
